// extracted by mini-css-extract-plugin
module.exports = {"input":"style_input__3Qfyy","tag":"style_tag__3No8f","handler":"style_handler__19rk_","disabled":"style_disabled__1m9C2"};